'use client';
import { withAuthenticationRequired } from '@/auth';
import MyExperiences from './components/my-experience';
import { FullPageLoader } from '@/components/full-page-loader/full-page-loader';

const AuthMyExperiencePage = withAuthenticationRequired(MyExperiences, {
  onRedirecting: () => <FullPageLoader>Redirecting to login page...</FullPageLoader>,
});

export default AuthMyExperiencePage as any;
